import { default as about1Q48rH9gFgMeta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsHCedoT2sHgMeta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93XBiNkyig1zMeta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleAy37ib1i08Meta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsGTPoPmZkQ3Meta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93JojkuR37vTMeta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewUhNdKQlJLDMeta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexp9b9sN2OaSMeta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93USbnALWP58Meta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexZCiLQvx5XaMeta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93qEaV17tiuxMeta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexgZQsHYTsSHMeta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionso3fwjxsKhRMeta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsbQYrkEanhPMeta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsX3yJfh1X1WMeta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_931K1FYJ6M3SMeta } from "/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexEjblSBzn1TMeta } from "/tmp/build_7ecca958/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirm43OCJphHdSMeta } from "/tmp/build_7ecca958/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmTQePjMQvueMeta } from "/tmp/build_7ecca958/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarVz0z4MAPlpMeta } from "/tmp/build_7ecca958/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatsC2e3i1dDYMeta } from "/tmp/build_7ecca958/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutBPJmUM9FJrMeta } from "/tmp/build_7ecca958/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedj2ZKjmAQHiMeta } from "/tmp/build_7ecca958/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersiZzZE6NjFcMeta } from "/tmp/build_7ecca958/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93yGyYrkuVIWMeta } from "/tmp/build_7ecca958/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editPQu5fVgWpjMeta } from "/tmp/build_7ecca958/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93Coe8RTTwypMeta } from "/tmp/build_7ecca958/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityJ5K6QcYbFhMeta } from "/tmp/build_7ecca958/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93pJEUzUmjArMeta } from "/tmp/build_7ecca958/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_933bEajoMMl1Meta } from "/tmp/build_7ecca958/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardYkXvqGtviTMeta } from "/tmp/build_7ecca958/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexS53i4kQidlMeta } from "/tmp/build_7ecca958/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutXtwaSIZTvBMeta } from "/tmp/build_7ecca958/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productXOkUlJYjb3Meta } from "/tmp/build_7ecca958/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventssrAUnRWkPHMeta } from "/tmp/build_7ecca958/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_930muO6CHBFKMeta } from "/tmp/build_7ecca958/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexUzH3fKagUdMeta } from "/tmp/build_7ecca958/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93JkTRUw48CGMeta } from "/tmp/build_7ecca958/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93obcUcQvpQXMeta } from "/tmp/build_7ecca958/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexFlmBUdA6KEMeta } from "/tmp/build_7ecca958/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93ghuMwkFIQbMeta } from "/tmp/build_7ecca958/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as join9ttFzO9P1BMeta } from "/tmp/build_7ecca958/pages/[studio_url]/join.vue?macro=true";
import { default as login4zd72jhq3DMeta } from "/tmp/build_7ecca958/pages/[studio_url]/login.vue?macro=true";
import { default as logoutncMCvhaIHoMeta } from "/tmp/build_7ecca958/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93iQYScZrWAgMeta } from "/tmp/build_7ecca958/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93bxruSVyjRoMeta } from "/tmp/build_7ecca958/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93WjWnoTxAdRMeta } from "/tmp/build_7ecca958/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritesvTyaduzIwqMeta } from "/tmp/build_7ecca958/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studiosNfRyrb0KjYMeta } from "/tmp/build_7ecca958/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinWazwhywIUYMeta } from "/tmp/build_7ecca958/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_933Lg5fy8irjMeta } from "/tmp/build_7ecca958/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexU6CkRm7nwGMeta } from "/tmp/build_7ecca958/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexqbDAAvj3IqMeta } from "/tmp/build_7ecca958/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutk5krQrjxBnMeta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentdPe2JmbHgPMeta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventsR1C3JTUiMAMeta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93a7t9WDld6kMeta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleLv9t72OJ0CMeta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsPqhUlNF38zMeta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93NnnISeuQqCMeta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as view18XWlftcSpMeta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexfuv5u7xGxEMeta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93ap3LCrvgM5Meta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexulzWbvwHP0Meta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93sRstSzfcimMeta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as index07qSfNzMTeMeta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsiuZxJ2nFa1Meta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsSBKoaqY3GbMeta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsLlxKpT2yPSMeta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93A04osPSt39Meta } from "/tmp/build_7ecca958/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexatDy1Pw8n2Meta } from "/tmp/build_7ecca958/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexVbWfcuq385Meta } from "/tmp/build_7ecca958/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesbcI6Gr5DFKMeta } from "/tmp/build_7ecca958/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsbPZ9p5vImaMeta } from "/tmp/build_7ecca958/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93GN9HgQYQg2Meta } from "/tmp/build_7ecca958/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93fBUW3ZDwCcMeta } from "/tmp/build_7ecca958/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as reset21jxxureQEMeta } from "/tmp/build_7ecca958/pages/[studio_url]/reset.vue?macro=true";
import { default as shoppOVz1iUd11Meta } from "/tmp/build_7ecca958/pages/[studio_url]/shop.vue?macro=true";
import { default as signupV2OLqT5Nq7Meta } from "/tmp/build_7ecca958/pages/[studio_url]/signup.vue?macro=true";
import { default as liveBl1vdJbkAnMeta } from "/tmp/build_7ecca958/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsEWPB8dneivMeta } from "/tmp/build_7ecca958/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93U6XQS63GQvMeta } from "/tmp/build_7ecca958/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactV2vmecYw61Meta } from "/tmp/build_7ecca958/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullIgR2PQ4XaGMeta } from "/tmp/build_7ecca958/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_931K1FYJ6M3SMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_931K1FYJ6M3SMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_931K1FYJ6M3SMeta || {},
    alias: _91product_id_931K1FYJ6M3SMeta?.alias || [],
    redirect: _91product_id_931K1FYJ6M3SMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: about1Q48rH9gFgMeta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: about1Q48rH9gFgMeta?.path ?? "about",
    meta: about1Q48rH9gFgMeta || {},
    alias: about1Q48rH9gFgMeta?.alias || [],
    redirect: about1Q48rH9gFgMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsHCedoT2sHgMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsHCedoT2sHgMeta?.path ?? "events",
    meta: eventsHCedoT2sHgMeta || {},
    alias: eventsHCedoT2sHgMeta?.alias || [],
    redirect: eventsHCedoT2sHgMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93XBiNkyig1zMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93XBiNkyig1zMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93XBiNkyig1zMeta || {},
    alias: _91media_id_93XBiNkyig1zMeta?.alias || [],
    redirect: _91media_id_93XBiNkyig1zMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleAy37ib1i08Meta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sampleAy37ib1i08Meta?.path ?? "free-sample",
    meta: free_45sampleAy37ib1i08Meta || {},
    alias: free_45sampleAy37ib1i08Meta?.alias || [],
    redirect: free_45sampleAy37ib1i08Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsGTPoPmZkQ3Meta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsGTPoPmZkQ3Meta?.path ?? "included-products",
    meta: included_45productsGTPoPmZkQ3Meta || {},
    alias: included_45productsGTPoPmZkQ3Meta?.alias || [],
    redirect: included_45productsGTPoPmZkQ3Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93JojkuR37vTMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93JojkuR37vTMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93JojkuR37vTMeta || {},
    alias: _91media_id_93JojkuR37vTMeta?.alias || [],
    redirect: _91media_id_93JojkuR37vTMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewUhNdKQlJLDMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewUhNdKQlJLDMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewUhNdKQlJLDMeta || {},
    alias: viewUhNdKQlJLDMeta?.alias || [],
    redirect: viewUhNdKQlJLDMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexp9b9sN2OaSMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexp9b9sN2OaSMeta?.path ?? "lessons",
    meta: indexp9b9sN2OaSMeta || {},
    alias: indexp9b9sN2OaSMeta?.alias || [],
    redirect: indexp9b9sN2OaSMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93USbnALWP58Meta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93USbnALWP58Meta?.path ?? "media/:media_id()",
    meta: _91media_id_93USbnALWP58Meta || {},
    alias: _91media_id_93USbnALWP58Meta?.alias || [],
    redirect: _91media_id_93USbnALWP58Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexZCiLQvx5XaMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexZCiLQvx5XaMeta?.path ?? "playlists/:playlist_id()",
    meta: indexZCiLQvx5XaMeta || {},
    alias: indexZCiLQvx5XaMeta?.alias || [],
    redirect: indexZCiLQvx5XaMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93qEaV17tiuxMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93qEaV17tiuxMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93qEaV17tiuxMeta || {},
    alias: _91media_id_93qEaV17tiuxMeta?.alias || [],
    redirect: _91media_id_93qEaV17tiuxMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexgZQsHYTsSHMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexgZQsHYTsSHMeta?.path ?? "playlists",
    meta: indexgZQsHYTsSHMeta || {},
    alias: indexgZQsHYTsSHMeta?.alias || [],
    redirect: indexgZQsHYTsSHMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionso3fwjxsKhRMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionso3fwjxsKhRMeta?.path ?? "private-sessions",
    meta: private_45sessionso3fwjxsKhRMeta || {},
    alias: private_45sessionso3fwjxsKhRMeta?.alias || [],
    redirect: private_45sessionso3fwjxsKhRMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsbQYrkEanhPMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsbQYrkEanhPMeta?.path ?? "recordings",
    meta: recordingsbQYrkEanhPMeta || {},
    alias: recordingsbQYrkEanhPMeta?.alias || [],
    redirect: recordingsbQYrkEanhPMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsX3yJfh1X1WMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsX3yJfh1X1WMeta?.path ?? "reviews",
    meta: reviewsX3yJfh1X1WMeta || {},
    alias: reviewsX3yJfh1X1WMeta?.alias || [],
    redirect: reviewsX3yJfh1X1WMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexEjblSBzn1TMeta?.name ?? "buy-product-product_id",
    path: indexEjblSBzn1TMeta?.path ?? "/buy/product/:product_id()",
    meta: indexEjblSBzn1TMeta || {},
    alias: indexEjblSBzn1TMeta?.alias || [],
    redirect: indexEjblSBzn1TMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirm43OCJphHdSMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirm43OCJphHdSMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirm43OCJphHdSMeta || {},
    alias: confirm43OCJphHdSMeta?.alias || [],
    redirect: confirm43OCJphHdSMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmTQePjMQvueMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmTQePjMQvueMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmTQePjMQvueMeta || {},
    alias: confirmTQePjMQvueMeta?.alias || [],
    redirect: confirmTQePjMQvueMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarVz0z4MAPlpMeta?.name ?? "calendar",
    path: calendarVz0z4MAPlpMeta?.path ?? "/calendar",
    meta: calendarVz0z4MAPlpMeta || {},
    alias: calendarVz0z4MAPlpMeta?.alias || [],
    redirect: calendarVz0z4MAPlpMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatsC2e3i1dDYMeta?.name ?? "chat",
    path: chatsC2e3i1dDYMeta?.path ?? "/chat",
    meta: chatsC2e3i1dDYMeta || {},
    alias: chatsC2e3i1dDYMeta?.alias || [],
    redirect: chatsC2e3i1dDYMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93yGyYrkuVIWMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93yGyYrkuVIWMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93yGyYrkuVIWMeta || {},
    alias: _91group_id_93yGyYrkuVIWMeta?.alias || [],
    redirect: _91group_id_93yGyYrkuVIWMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutBPJmUM9FJrMeta?.name ?? "community-groups-group_id-about",
    path: aboutBPJmUM9FJrMeta?.path ?? "about",
    meta: aboutBPJmUM9FJrMeta || {},
    alias: aboutBPJmUM9FJrMeta?.alias || [],
    redirect: aboutBPJmUM9FJrMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedj2ZKjmAQHiMeta?.name ?? "community-groups-group_id-feed",
    path: feedj2ZKjmAQHiMeta?.path ?? "feed",
    meta: feedj2ZKjmAQHiMeta || {},
    alias: feedj2ZKjmAQHiMeta?.alias || [],
    redirect: feedj2ZKjmAQHiMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersiZzZE6NjFcMeta?.name ?? "community-groups-group_id-members",
    path: membersiZzZE6NjFcMeta?.path ?? "members",
    meta: membersiZzZE6NjFcMeta || {},
    alias: membersiZzZE6NjFcMeta?.alias || [],
    redirect: membersiZzZE6NjFcMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editPQu5fVgWpjMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editPQu5fVgWpjMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editPQu5fVgWpjMeta || {},
    alias: community_45profile_45editPQu5fVgWpjMeta?.alias || [],
    redirect: community_45profile_45editPQu5fVgWpjMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Coe8RTTwypMeta?.name ?? "community-profile-id",
    path: _91id_93Coe8RTTwypMeta?.path ?? "/community-profile/:id()",
    meta: _91id_93Coe8RTTwypMeta || {},
    alias: _91id_93Coe8RTTwypMeta?.alias || [],
    redirect: _91id_93Coe8RTTwypMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityJ5K6QcYbFhMeta?.name ?? "community",
    path: communityJ5K6QcYbFhMeta?.path ?? "/community",
    meta: communityJ5K6QcYbFhMeta || {},
    alias: communityJ5K6QcYbFhMeta?.alias || [],
    redirect: communityJ5K6QcYbFhMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93pJEUzUmjArMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93pJEUzUmjArMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93pJEUzUmjArMeta || {},
    alias: _91uuid_93pJEUzUmjArMeta?.alias || [],
    redirect: _91uuid_93pJEUzUmjArMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_933bEajoMMl1Meta?.name ?? "contracts-unique_id",
    path: _91unique_id_933bEajoMMl1Meta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_933bEajoMMl1Meta || {},
    alias: _91unique_id_933bEajoMMl1Meta?.alias || [],
    redirect: _91unique_id_933bEajoMMl1Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardYkXvqGtviTMeta?.name ?? "dashboard",
    path: dashboardYkXvqGtviTMeta?.path ?? "/dashboard",
    meta: dashboardYkXvqGtviTMeta || {},
    alias: dashboardYkXvqGtviTMeta?.alias || [],
    redirect: dashboardYkXvqGtviTMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexS53i4kQidlMeta?.name ?? "event-details-event_id",
    path: indexS53i4kQidlMeta?.path ?? "/event/details/:event_id()",
    meta: indexS53i4kQidlMeta || {},
    alias: indexS53i4kQidlMeta?.alias || [],
    redirect: indexS53i4kQidlMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutXtwaSIZTvBMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutXtwaSIZTvBMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutXtwaSIZTvBMeta || {},
    alias: checkoutXtwaSIZTvBMeta?.alias || [],
    redirect: checkoutXtwaSIZTvBMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productXOkUlJYjb3Meta?.name ?? "event-details-event_id-select-product",
    path: select_45productXOkUlJYjb3Meta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productXOkUlJYjb3Meta || {},
    alias: select_45productXOkUlJYjb3Meta?.alias || [],
    redirect: select_45productXOkUlJYjb3Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventssrAUnRWkPHMeta?.name ?? "events",
    path: eventssrAUnRWkPHMeta?.path ?? "/events",
    meta: eventssrAUnRWkPHMeta || {},
    alias: eventssrAUnRWkPHMeta?.alias || [],
    redirect: eventssrAUnRWkPHMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_930muO6CHBFKMeta?.name ?? "gifts-uuid",
    path: _91uuid_930muO6CHBFKMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_930muO6CHBFKMeta || {},
    alias: _91uuid_930muO6CHBFKMeta?.alias || [],
    redirect: _91uuid_930muO6CHBFKMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexUzH3fKagUdMeta?.name ?? "gifts",
    path: indexUzH3fKagUdMeta?.path ?? "/gifts",
    meta: indexUzH3fKagUdMeta || {},
    alias: indexUzH3fKagUdMeta?.alias || [],
    redirect: indexUzH3fKagUdMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93JkTRUw48CGMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93JkTRUw48CGMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93JkTRUw48CGMeta || {},
    alias: _91invitation_id_93JkTRUw48CGMeta?.alias || [],
    redirect: _91invitation_id_93JkTRUw48CGMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93obcUcQvpQXMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93obcUcQvpQXMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93obcUcQvpQXMeta || {},
    alias: _91product_id_93obcUcQvpQXMeta?.alias || [],
    redirect: _91product_id_93obcUcQvpQXMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexFlmBUdA6KEMeta?.name ?? "index",
    path: indexFlmBUdA6KEMeta?.path ?? "/",
    meta: indexFlmBUdA6KEMeta || {},
    alias: indexFlmBUdA6KEMeta?.alias || [],
    redirect: indexFlmBUdA6KEMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93ghuMwkFIQbMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93ghuMwkFIQbMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93ghuMwkFIQbMeta || {},
    alias: _91invitation_unique_id_93ghuMwkFIQbMeta?.alias || [],
    redirect: _91invitation_unique_id_93ghuMwkFIQbMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: join9ttFzO9P1BMeta?.name ?? "join",
    path: join9ttFzO9P1BMeta?.path ?? "/join",
    meta: join9ttFzO9P1BMeta || {},
    alias: join9ttFzO9P1BMeta?.alias || [],
    redirect: join9ttFzO9P1BMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: login4zd72jhq3DMeta?.name ?? "login",
    path: login4zd72jhq3DMeta?.path ?? "/login",
    meta: login4zd72jhq3DMeta || {},
    alias: login4zd72jhq3DMeta?.alias || [],
    redirect: login4zd72jhq3DMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutncMCvhaIHoMeta?.name ?? "logout",
    path: logoutncMCvhaIHoMeta?.path ?? "/logout",
    meta: logoutncMCvhaIHoMeta || {},
    alias: logoutncMCvhaIHoMeta?.alias || [],
    redirect: logoutncMCvhaIHoMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93iQYScZrWAgMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93iQYScZrWAgMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93iQYScZrWAgMeta || {},
    alias: _91meeting_type_slug_93iQYScZrWAgMeta?.alias || [],
    redirect: _91meeting_type_slug_93iQYScZrWAgMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93bxruSVyjRoMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93bxruSVyjRoMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93bxruSVyjRoMeta || {},
    alias: _91meeting_unique_id_93bxruSVyjRoMeta?.alias || [],
    redirect: _91meeting_unique_id_93bxruSVyjRoMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93WjWnoTxAdRMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93WjWnoTxAdRMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93WjWnoTxAdRMeta || {},
    alias: _91meeting_unique_id_93WjWnoTxAdRMeta?.alias || [],
    redirect: _91meeting_unique_id_93WjWnoTxAdRMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesvTyaduzIwqMeta?.name ?? "my-favorites",
    path: my_45favoritesvTyaduzIwqMeta?.path ?? "/my-favorites",
    meta: my_45favoritesvTyaduzIwqMeta || {},
    alias: my_45favoritesvTyaduzIwqMeta?.alias || [],
    redirect: my_45favoritesvTyaduzIwqMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studiosNfRyrb0KjYMeta?.name ?? "my-studios",
    path: my_45studiosNfRyrb0KjYMeta?.path ?? "/my-studios",
    meta: my_45studiosNfRyrb0KjYMeta || {},
    alias: my_45studiosNfRyrb0KjYMeta?.alias || [],
    redirect: my_45studiosNfRyrb0KjYMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinWazwhywIUYMeta?.name ?? "optin",
    path: optinWazwhywIUYMeta?.path ?? "/optin",
    meta: optinWazwhywIUYMeta || {},
    alias: optinWazwhywIUYMeta?.alias || [],
    redirect: optinWazwhywIUYMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_933Lg5fy8irjMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_933Lg5fy8irjMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_933Lg5fy8irjMeta || {},
    alias: _91episode_id_933Lg5fy8irjMeta?.alias || [],
    redirect: _91episode_id_933Lg5fy8irjMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexU6CkRm7nwGMeta?.name ?? "podcasts-podcast_id",
    path: indexU6CkRm7nwGMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexU6CkRm7nwGMeta || {},
    alias: indexU6CkRm7nwGMeta?.alias || [],
    redirect: indexU6CkRm7nwGMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexqbDAAvj3IqMeta?.name ?? "podcasts",
    path: indexqbDAAvj3IqMeta?.path ?? "/podcasts",
    meta: indexqbDAAvj3IqMeta || {},
    alias: indexqbDAAvj3IqMeta?.alias || [],
    redirect: indexqbDAAvj3IqMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93A04osPSt39Meta?.name ?? "product-product_id",
    path: _91product_id_93A04osPSt39Meta?.path ?? "/product/:product_id()",
    meta: _91product_id_93A04osPSt39Meta || {},
    alias: _91product_id_93A04osPSt39Meta?.alias || [],
    redirect: _91product_id_93A04osPSt39Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutk5krQrjxBnMeta?.name ?? "product-product_id-about",
    path: aboutk5krQrjxBnMeta?.path ?? "about",
    meta: aboutk5krQrjxBnMeta || {},
    alias: aboutk5krQrjxBnMeta?.alias || [],
    redirect: aboutk5krQrjxBnMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentdPe2JmbHgPMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentdPe2JmbHgPMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentdPe2JmbHgPMeta || {},
    alias: digital_45download_45contentdPe2JmbHgPMeta?.alias || [],
    redirect: digital_45download_45contentdPe2JmbHgPMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventsR1C3JTUiMAMeta?.name ?? "product-product_id-events",
    path: eventsR1C3JTUiMAMeta?.path ?? "events",
    meta: eventsR1C3JTUiMAMeta || {},
    alias: eventsR1C3JTUiMAMeta?.alias || [],
    redirect: eventsR1C3JTUiMAMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93a7t9WDld6kMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93a7t9WDld6kMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93a7t9WDld6kMeta || {},
    alias: _91media_id_93a7t9WDld6kMeta?.alias || [],
    redirect: _91media_id_93a7t9WDld6kMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleLv9t72OJ0CMeta?.name ?? "product-product_id-free-sample",
    path: free_45sampleLv9t72OJ0CMeta?.path ?? "free-sample",
    meta: free_45sampleLv9t72OJ0CMeta || {},
    alias: free_45sampleLv9t72OJ0CMeta?.alias || [],
    redirect: free_45sampleLv9t72OJ0CMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsPqhUlNF38zMeta?.name ?? "product-product_id-included-products",
    path: included_45productsPqhUlNF38zMeta?.path ?? "included-products",
    meta: included_45productsPqhUlNF38zMeta || {},
    alias: included_45productsPqhUlNF38zMeta?.alias || [],
    redirect: included_45productsPqhUlNF38zMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93NnnISeuQqCMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93NnnISeuQqCMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93NnnISeuQqCMeta || {},
    alias: _91media_id_93NnnISeuQqCMeta?.alias || [],
    redirect: _91media_id_93NnnISeuQqCMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: view18XWlftcSpMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: view18XWlftcSpMeta?.path ?? "lessons/:lesson_id()/view",
    meta: view18XWlftcSpMeta || {},
    alias: view18XWlftcSpMeta?.alias || [],
    redirect: view18XWlftcSpMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexfuv5u7xGxEMeta?.name ?? "product-product_id-lessons",
    path: indexfuv5u7xGxEMeta?.path ?? "lessons",
    meta: indexfuv5u7xGxEMeta || {},
    alias: indexfuv5u7xGxEMeta?.alias || [],
    redirect: indexfuv5u7xGxEMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93ap3LCrvgM5Meta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93ap3LCrvgM5Meta?.path ?? "media/:media_id()",
    meta: _91media_id_93ap3LCrvgM5Meta || {},
    alias: _91media_id_93ap3LCrvgM5Meta?.alias || [],
    redirect: _91media_id_93ap3LCrvgM5Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexulzWbvwHP0Meta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexulzWbvwHP0Meta?.path ?? "playlists/:playlist_id()",
    meta: indexulzWbvwHP0Meta || {},
    alias: indexulzWbvwHP0Meta?.alias || [],
    redirect: indexulzWbvwHP0Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93sRstSzfcimMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93sRstSzfcimMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93sRstSzfcimMeta || {},
    alias: _91media_id_93sRstSzfcimMeta?.alias || [],
    redirect: _91media_id_93sRstSzfcimMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index07qSfNzMTeMeta?.name ?? "product-product_id-playlists",
    path: index07qSfNzMTeMeta?.path ?? "playlists",
    meta: index07qSfNzMTeMeta || {},
    alias: index07qSfNzMTeMeta?.alias || [],
    redirect: index07qSfNzMTeMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsiuZxJ2nFa1Meta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsiuZxJ2nFa1Meta?.path ?? "private-sessions",
    meta: private_45sessionsiuZxJ2nFa1Meta || {},
    alias: private_45sessionsiuZxJ2nFa1Meta?.alias || [],
    redirect: private_45sessionsiuZxJ2nFa1Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsSBKoaqY3GbMeta?.name ?? "product-product_id-recordings",
    path: recordingsSBKoaqY3GbMeta?.path ?? "recordings",
    meta: recordingsSBKoaqY3GbMeta || {},
    alias: recordingsSBKoaqY3GbMeta?.alias || [],
    redirect: recordingsSBKoaqY3GbMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsLlxKpT2yPSMeta?.name ?? "product-product_id-reviews",
    path: reviewsLlxKpT2yPSMeta?.path ?? "reviews",
    meta: reviewsLlxKpT2yPSMeta || {},
    alias: reviewsLlxKpT2yPSMeta?.alias || [],
    redirect: reviewsLlxKpT2yPSMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexatDy1Pw8n2Meta?.name ?? "product",
    path: indexatDy1Pw8n2Meta?.path ?? "/product",
    meta: indexatDy1Pw8n2Meta || {},
    alias: indexatDy1Pw8n2Meta?.alias || [],
    redirect: indexatDy1Pw8n2Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexVbWfcuq385Meta?.name ?? "profile",
    path: indexVbWfcuq385Meta?.path ?? "/profile",
    meta: indexVbWfcuq385Meta || {},
    alias: indexVbWfcuq385Meta?.alias || [],
    redirect: indexVbWfcuq385Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesbcI6Gr5DFKMeta?.name ?? "profile-purchases",
    path: purchasesbcI6Gr5DFKMeta?.path ?? "/profile/purchases",
    meta: purchasesbcI6Gr5DFKMeta || {},
    alias: purchasesbcI6Gr5DFKMeta?.alias || [],
    redirect: purchasesbcI6Gr5DFKMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsbPZ9p5vImaMeta?.name ?? "profile-redemptions",
    path: redemptionsbPZ9p5vImaMeta?.path ?? "/profile/redemptions",
    meta: redemptionsbPZ9p5vImaMeta || {},
    alias: redemptionsbPZ9p5vImaMeta?.alias || [],
    redirect: redemptionsbPZ9p5vImaMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93GN9HgQYQg2Meta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93GN9HgQYQg2Meta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93GN9HgQYQg2Meta || {},
    alias: _91quiz_id_93GN9HgQYQg2Meta?.alias || [],
    redirect: _91quiz_id_93GN9HgQYQg2Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93fBUW3ZDwCcMeta?.name ?? "reset-password-uid-token",
    path: _91token_93fBUW3ZDwCcMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93fBUW3ZDwCcMeta || {},
    alias: _91token_93fBUW3ZDwCcMeta?.alias || [],
    redirect: _91token_93fBUW3ZDwCcMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: reset21jxxureQEMeta?.name ?? "reset",
    path: reset21jxxureQEMeta?.path ?? "/reset",
    meta: reset21jxxureQEMeta || {},
    alias: reset21jxxureQEMeta?.alias || [],
    redirect: reset21jxxureQEMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shoppOVz1iUd11Meta?.name ?? "shop",
    path: shoppOVz1iUd11Meta?.path ?? "/shop",
    meta: shoppOVz1iUd11Meta || {},
    alias: shoppOVz1iUd11Meta?.alias || [],
    redirect: shoppOVz1iUd11Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupV2OLqT5Nq7Meta?.name ?? "signup",
    path: signupV2OLqT5Nq7Meta?.path ?? "/signup",
    meta: signupV2OLqT5Nq7Meta || {},
    alias: signupV2OLqT5Nq7Meta?.alias || [],
    redirect: signupV2OLqT5Nq7Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveBl1vdJbkAnMeta?.name ?? "streaming-event_id-live",
    path: liveBl1vdJbkAnMeta?.path ?? "/streaming/:event_id()/live",
    meta: liveBl1vdJbkAnMeta || {},
    alias: liveBl1vdJbkAnMeta?.alias || [],
    redirect: liveBl1vdJbkAnMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsEWPB8dneivMeta?.name ?? "tips",
    path: tipsEWPB8dneivMeta?.path ?? "/tips",
    meta: tipsEWPB8dneivMeta || {},
    alias: tipsEWPB8dneivMeta?.alias || [],
    redirect: tipsEWPB8dneivMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93U6XQS63GQvMeta?.name ?? "waiver-uuid",
    path: _91uuid_93U6XQS63GQvMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93U6XQS63GQvMeta || {},
    alias: _91uuid_93U6XQS63GQvMeta?.alias || [],
    redirect: _91uuid_93U6XQS63GQvMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactV2vmecYw61Meta?.name ?? "widgets-calendars-compact",
    path: compactV2vmecYw61Meta?.path ?? "/widgets/calendars/compact",
    meta: compactV2vmecYw61Meta || {},
    alias: compactV2vmecYw61Meta?.alias || [],
    redirect: compactV2vmecYw61Meta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullIgR2PQ4XaGMeta?.name ?? "widgets-calendars-full",
    path: fullIgR2PQ4XaGMeta?.path ?? "/widgets/calendars/full",
    meta: fullIgR2PQ4XaGMeta || {},
    alias: fullIgR2PQ4XaGMeta?.alias || [],
    redirect: fullIgR2PQ4XaGMeta?.redirect,
    component: () => import("/tmp/build_7ecca958/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]